<template>
    <div style="display: flex; flex-direction: column; background-color: #fff;">
        <div style="margin-top: 31px; position: relative; display: flex; margin-bottom: 16px; align-items: center; justify-content: space-between; padding: 0 12px;">
            <div style="display:flex; align-items: center; " @click="() => { $GlobalStore.closeLastModal() }">
                <img :src="require('@/assets/img/ico-move_black.png')" style="width: 10px;">
                <span style="font-size:14px; font-weight:500; margin-left:5px; color:#210F03;">뒤로가기</span>
            </div>
            <div style="padding: 8px 16px; position: absolute; left: 50%; transform: translateX(-50%); display: inline-block; font-size: 14px; line-height: 20px; font-weight: 700; border-radius: 20px; background: #210F03E5; text-align: center; color: #fff;">
                {{pollPostDetail.view_cnt | comma}}명이 조회
            </div>
        </div>
        <InfinityScroll :refresh-action="refreshDetail" style="flex: 1; overflow: hidden;">
            <div style="height: 100%; padding: 0 12px; overflow-y: scroll;">
                <div v-if="Object.keys(pollPostDetail).length > 0" style="margin-top: 20px;">
                    <CommonPollPost :isDetail="true" :setLikeState="setLikeState" :pollPost="pollPostDetail"></CommonPollPost>
                </div>
                <div ref="test" style="margin-top: 20px;">
                    <div style="display: flex; gap: 12px; justify-content: center;">
                        <div @click.stop="() => { }" @touchstart.stop="touchStart($event)" @touchend.stop="touchEnd($event)" style="border-radius: 20px; background-color: #210F031A;">
                            <div style="padding: 12px 28px; font-size: 14px; text-align: center; font-weight: 700; border-radius: 20px; display: flex; align-items: center; gap: 4px;">
                                <div style="position: relative;">
                                    <img :style="{ opacity: curLikeYn === IS_LIKE.LIKE ? '1' : '0' }" ref="shoot" style="width: 40px; z-index: 1; opacity: 0; left: -23px; position: absolute; top: -1px;" :src="require('@/assets/img/shoot_orange.png')" alt="">
                                    <img style="width: 16px; position: relative; z-index: 2;" ref="soccerBall" :src="require('@/assets/img/soccer_ball_reply_active.png')" alt="">
                                    <!-- <img v-else style="width: 16px; position: relative; z-index: 2;" :src="require('@/assets/img/soccer_ball_reply_active.png')" alt=""> -->
                                </div>
                                <div>{{ curLikeNumber }}</div>
                            </div>
                        </div>
                        <InteractionOfBtnBackgroundColor style="border-radius: 20px;" originColor="#210F031A" completeColor="#FF711180" changeColor="#D9D9D9" :curType="BTN_TYPE.REPLY" :btnType="BTN_TYPE.REPLY">
                            <div style="padding: 12px 20px; line-height: 16px; font-size: 14px; text-align: center; font-weight: 700; border-radius: 20px;">댓글 {{ replies.length }}</div>
                        </InteractionOfBtnBackgroundColor>
                    </div>
                </div>
                <div style="margin-top: 20px;">
                    <template>
                        <CommonReply :poll_idx="pollPostDetail.idx" :isHideOption="true" :completeAction="getReplyList" :replies="replies" :curCommentReplyIdx="cur_reply_soccerhow_idx" :setReplyIdx="setReplyIdx"></CommonReply>
                    </template>
                </div>
            </div>
        </InfinityScroll>
        <template>
            <div style=" display:flex; width:100%; padding:8px 12px; align-items: flex-end; background-color: white; border-top:1px solid #F5F5F5;">
                <div style="flex:1; position: relative; display: flex; gap: 8px;">
                    <ProfileImage :imagePath="myImagePath" style="width: 40px; height: 40px"></ProfileImage>
                    <div style="display:flex; flex:1; background-color: #efefef; border-radius:25px; align-items: center;; background-color: #efefef;  border-radius:20px; ">
                        <div v-if="cur_reply_soccerhow_idx !== -1" style="font-size:14px; color:var(--color-main); padding-left: 12px;">@{{ inputNicName }}</div>
                        <textarea rows="1" ref="chatInput" style="background-color:transparent; flex:1; width: 100%; max-height: 350px; resize:none; outline: none; border:0px; padding: 10px 15px; padding-right: 40px; font-size:14px; line-height:20px; overflow:hidden; overflow-y: scroll;" placeholder="댓글 달기" v-model="replyContents" oninput='this.style.height = ""; this.style.height = (this.scrollHeight) + "px"' @focus="checkLogin" @input="calcContentsLength($event)" @click="$Util.sendEventClick('사커하우_댓글달기')"></textarea>
                    </div>
                    <div>
                        <div v-if="contentsLength === 0" style="width: 32px; height: 32px; display: flex; justify-content: center; align-items: center; position: absolute; right: 12px; top: 50%; transform: translateY(-50%); background-color: #D9D9D9; border-radius: 50%;">
                            <img :src="require('@/assets/img/chat_send_white.png')" style="width:12px; height:16px;">
                        </div>
                        <div @click="submitReply" v-else style="width: 32px; background-color: #210f03; display: flex; align-items: center; justify-content: center; height: 32px; border-radius: 50%; display: flex; justify-content: center; position: absolute; right: 12px; top: 50%; transform: translateY(-50%);">
                            <img :src="require('@/assets/img/chat_send_white.png')" style="width:12px; height:16px;">
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
const BTN_TYPE = {
    REQUEST: '요청',
    ALARM: '알림',
    REPLY: '댓글'
}

import { SOCCER_HOW_TYPE } from '@/Constants'
import ProfileImage from '@/components/common/ProfileImage'
import ResponseCode from '@/ResponseCode'
import InfinityScroll from '@/components/common/InfinityScroll'
import CommonReply from '@/components/common/CommonReply'
import InteractionOfBtnBackgroundColor from '@/components/common/InteractionOfBtnBackgroundColor';
import CommonPollPost from '@/components/common/CommonPollPost'

const IS_LIKE = {
    LIKE: 1,
    UNLIKE: 0
}

export default {
    name: 'PollPostDetail',
    components: { ProfileImage, InteractionOfBtnBackgroundColor, CommonPollPost, CommonReply, InfinityScroll },
    props: {
        poll_idx: {
            type: [Number, String],
            default: -1
        }
    },
    data() {
        return {
            BTN_TYPE: BTN_TYPE,
            cur_reply_soccerhow_idx: -1,
            inputNicName: null,
            contentsLength: 0,
            contents: '',
            replies: [],
            pollPostDetail: {},
            replyContents: '',
            is_me_member_liked: false,
            cur_modal_length: -1,
            isActiveCommentReply: false,
            IS_LIKE: IS_LIKE
        };
    },
    beforeDestroy() {
        window.visualViewport.removeEventListener('resize', this.detectResize);
    },
    mounted() {
        window.visualViewport.addEventListener("resize", this.detectResize);
    },
    created() {
        this.submitReply = this.$Once(this.submitReply)
        this.sendLike = this.$Once(this.sendLike)
        this.getPollDetail()
        this.getReplyList()
    },
    computed: {
        myImagePath() {
            return this.$GlobalStore.isLogin() ? this.$GlobalStore.loginInfo().image_path : null
        },
        curLikeYn() {
            return this.pollPostDetail.is_me_liked ? 1 : 0
        },
        curLikeNumber() {
            if (this.pollPostDetail.like_number === null || !this.pollPostDetail.like_number) {
                return 0
            } else {
                return parseInt(this.pollPostDetail.like_number)
            }
        },
    },
    methods: {
        touchStart() {
            if (!this.$GlobalStore.isLogin()) {
                return
            }

            if (this.curLikeYn === IS_LIKE.UNLIKE) {
                this.$refs.soccerBall.style.transform = 'rotate(-180deg)'
                this.$refs.soccerBall.style.transition = 'all 0.3s'
            }
        },
        touchEnd() {
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
            if (this.curLikeYn === IS_LIKE.UNLIKE) {
                this.$refs.soccerBall.style.transition = 'all 0.3s'
                this.$refs.soccerBall.style.transform = 'rotate(0)'
                this.$refs.shoot.style.opacity = '1'
                this.$refs.shoot.style.transition = 'all 0.3s'
            } else {
                this.$refs.shoot.style.transition = ''
                this.$refs.shoot.style.opacity = '0'
            }
            let likeTemp = this.curLikeYn === IS_LIKE.UNLIKE ? '1' : '0'
            let likeNumber = this.curLikeYn === IS_LIKE.UNLIKE ? this.curLikeNumber + 1 : this.curLikeNumber - 1
            this.setLikeState(likeTemp, likeNumber)
            this.toggleLike();
            this.$Util.vibrate();
        },
        async toggleLike() {
            const parameters = {};
            parameters.likeYn = this.curLikeYn === IS_LIKE.UNLIKE ? '0' : '1';
            parameters.idx = this.pollPostDetail.idx

            const res = await this.$Axios.post('/api/poll/like', parameters);
            this.$Util.sendEventClick('투표_좋아요', true)
            if (res.data.code === -1) {
                alert(res.data.msg);
            }
        },
        setLikeState(likeTemp, likeNumber) {
            this.$set(this.pollPostDetail, 'is_me_liked', likeTemp == 1 ? true : false);
            this.$set(this.pollPostDetail, 'like_number', likeNumber);
        },
        setReplyIdx(replyInfo) {
            if (!this.isActiveCommentReply) {
                this.cur_reply_soccerhow_idx = replyInfo.idx
                this.inputNicName = replyInfo.nic_name
                this.isActiveCommentReply = true
                this.$refs.chatInput.focus()
            } else {
                this.cur_reply_soccerhow_idx = -1
                this.inputNicName = null
                this.isActiveCommentReply = false
            }
        },
        detectResize() {
            if (window.visualViewport.offsetTop === 0) {
                if (this.$cookies.get('device') === 'ios') {
                    this.$GlobalStore.unsetLastModalFixedInIOS(this.cur_modal_length - 1);
                }
            } else {
                if (this.$cookies.get('device') === 'ios') {
                    this.$GlobalStore.setLastModalFixedInIOS(window.visualViewport.offsetTop, window.visualViewport.height);
                }
            }
        },
        goReplyTop() {
            this.$nextTick(() => {
                const target = this.$refs.test;
                if (target) {
                    target.scrollIntoView({ behavior: "smooth", block: "nearest" });
                }
            });
        },
        refreshDetail() {
            this.replies = []
            this.soccerhow = {}
            this.youtubeLink = ''
            this.contents = ''
            this.getReplyList()
        },
        calcContentsLength(e) {
            this.contentsLength = e.target.value.length
        },
        async submitReply() {
            if (this.replyContents === '') {
                this.$GlobalStore.showAlert('내용을 입력하세요.')
                return
            }
            const formData = new FormData()

            formData.append('contents', this.replyContents);
            formData.append('refer_idx', this.pollPostDetail.idx);
            formData.append('type', SOCCER_HOW_TYPE.REPLY);
            formData.append('reply_to_member_idx', this.$GlobalStore.loginInfo().idx)
            formData.append('is_poll', true)
            const res = await this.$Axios.post('/api/soccerhow/save', formData);

            if (res.data.code === ResponseCode.SUCCESS) {
                this.$Util.sendEventClick('투표_댓글달기', true)
                this.getPollDetail()
                this.getReplyList()
                this.goReplyTop()
                this.replyContents = ''
                this.inputNicName = null
                this.cur_reply_soccerhow_idx = -1
                this.contentsLength = 0
                this.$refs.chatInput.style.height = '40px'
                this.isActiveCommentReply = false
            }
        },
        async getPollDetail() {
            const parameters = {}
            parameters.idx = this.poll_idx

            const res = await this.$Axios.get('/api/poll/detail', { params: parameters })

            const pollPostDetail = res.data.poll
            this.pollPostDetail = pollPostDetail
        },
        async getReplyList() {
            const parameters = {}
            parameters.refer_idx = this.poll_idx
            parameters.replyDeep = 1
            parameters.parent_type = 'reply'
            parameters.child_type = 'reply'

            const res = await this.$Axios.get('/api/soccerhow/replies', { params: parameters })
            this.replies = res.data.replies
        },
        checkLogin() {
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
        },
        async sendLike() {
            const formData = new FormData()
            formData.append('target_idx', this.soccerhow.writer_idx);
            formData.append('from', this.isFromChatRuqest ? 'request' : 'training')
            formData.append('refer_idx', this.soccerhow.idx);
            formData.append('is_from_detail', true);

            const res = await this.$Axios.post('/api/like/soccerhow/interest/save', formData)
            if (res.data.code === ResponseCode.SUCCESS) {
                this.is_me_member_liked = true;
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        async cancelMemberLike() {
            const parameters = {};
            parameters.soccerhow_idx = this.soccerhow.idx;
            const res = await this.$Axios.post('/api/like/soccerhow/interest/delete', parameters)
            if (res.data.code === ResponseCode.SUCCESS) {
                this.is_me_member_liked = false;
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
    }
}
</script>

<style scoped></style>